export const selectors = {
    PRINT_ROOT: 'print-root',
    PRINT_SHOW: 'print-show',
    PRINT_HIDE: 'print-hide',
    PRINT_BE_SHORTER: 'print-be-shorter',
};
